var moment = require("moment");

// To configure console.log dynamic
export const Log = (message, debug) => {
    if (debug) {
        console.log(message);
    }
};
export const capitalize = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};

export const validateEmail = (email) => {
    // const pattern = /[a-zA-Z0-9]+[\.]?([a-zA-Z0-9]+)?[\@][a-z]{3,9}[\.][a-z]{2,5}/g;

    // Current expression - in Prod
    // const pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;

    // This expression accept all the characters of any length.
    // const pattern = /^.+@[^\.].*\.[a-z]{2,}$/;

    // Checking for occurance of @
    const countAtTheRate = email.split("@");

    // MyRoof expression for email check
    // new RegExp(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i);

    // No special character after @, only multiple . allowed after @
    if (countAtTheRate.length == 2) {
        if (
            countAtTheRate[1].charAt(0) === "." ||
            countAtTheRate[1].charAt(0) === "_" ||
            countAtTheRate[1].charAt(0) === "-"
        ) {
            return false;
        } else {
            const pattern = /^[A-Z0-9._%+-~^]+@[A-Z0-9._-]+\.[A-Z]{2,}$/i;
            const result = pattern.test(email);
            return result;
        }
    } else {
        return false;
    }
};

export const validatePhoneNumber = (phone) => {
    const pattern1 = /^[0-9]{3}(-| )[0-9]{3}(-| )[0-9]{4}$/;
    const pattern2 = /^(\+1)?[0-9]{10}$/;
    const pattern3 = /^(\([0-9]{3}\)( )?|[0-9]{3}(-| ))[0-9]{3}(-| )[0-9]{4}$/;
    if (pattern1.test(phone) || pattern2.test(phone) || pattern3.test(phone)) {
        return true;
    }
    return false;
};

export const convertDate = (orderDate) => {
    if(orderDate) {
        let utcDate = moment.utc(orderDate).toDate();
        let orderDateConverted = moment(utcDate)
            .format("MM/DD/YY hh:mm A")
            .replace(" ", " at ");
    
        return orderDateConverted;
    } else {
        return "-";
    }
   
};

export const checkSpeicalCharacter = (searchText) => {
    // /[&\/\\#,+()$~%.'":*?<>{}]/g
    // new RegExp(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i);
    const pattern = /[&\/\\+()~%'"^:*?<>{}]/g;
    const result = pattern.test(searchText);
    return result;
};

// This function will keep alphanumeric characters, spaces, dash and comma in a
// string and remove rest of all special characters
export const removeSpecialCharacter = (str) => {
    let result = "";
    result = str.replace(/[^a-zA-Z0-9\s\-,]/g, " ");
    //  str.replace(/[^\w\s\-\/,]/g, " ");
    console.log(result);
    return result;
};

export const currencyFormat = (value) =>
    new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
    }).format(value);

// Regex to allow only numbers and optional two decimals.
export const numberInputKeyPress = (val, shouldAllowDecimal) => {
    // const pattern = /^\d*(\.)?(\d{0,2})?$/ // This will allow two deciaml point
    const pattern =
        shouldAllowDecimal === true ? /^\d*(\.)?(\d{0,2})?$/ : /^\d*?$/;
    const result = pattern.test(val);
    if (!result) {
        return false;
    }
    return true;
};

export const textTruncate = (str, length, ending) => {
    if (length == null) {
        length = 10;
    }
    if (ending == null) {
        ending = "...";
    }
    if (str.length > length) {
        return str.substring(0, length - ending.length) + ending;
    } else {
        return str;
    }
};

export const checkValidUser = (associatedGAFCertification, profileName) => {
    const certificationArray = ["QM_SUPER_ADMIN", "QM_ADMIN"];
    const profileNameArray = ["ADM", "SADM"];

    // Redirect user if they are not valid users with valid profileName
    if (
        certificationArray.indexOf(associatedGAFCertification) === -1 &&
        profileNameArray.indexOf(profileName) === -1
    ) {
        return false;
    }
    return true;
};

export const checkValidSuperAdminUser = (
    associatedGAFCertification,
    profileName
) => {
    if (
        associatedGAFCertification !== "QM_SUPER_ADMIN" &&
        profileName !== "SADM"
    ) {
        return false;
    }

    return true;
};

export const productCodeCreditObj = (value, amt) => {
    let fullName = "";
    let Amount = 0;
    switch (value) {
        case "SF":
            fullName = "Single Family";
            Amount = amt;
            break;
        case "MF":
            fullName = "Multi-family";
            Amount = amt;
            break;
        case "CM":
            fullName = "Commercial";
            Amount = amt;
            break;
    }
    return { fullName, Amount };
};

export const productCodeCreditObjGuest = (value, creditArray) => {
    let fullName = "";
    let creditVal = 0;
    switch (value) {
        case "SF":
            fullName = "Single Family";
            creditVal = creditArray[0].amount;
            break;
        case "MF":
            fullName = "Multi-family";
            creditVal = creditArray[1].amount;
            break;
        case "CM":
            fullName = "Commercial";
            creditVal = creditArray[2].amount;
            break;
    }
    return { fullName, creditVal };
};

export const getReportNames = (code) => {
    let reportName = "";
    switch (code) {
        case "RM":
        case "Roof Measurement":
            reportName = "Roof Measurment";
            break;
        case "RC":
            reportName = "Roof Condition";
            break;
        case "WHPI":
            reportName = "Weather History";
            break;
        case "BC":
            reportName = "Building Codes";
            break;
        case "QuickSite Report":
            reportName = "QuickSite Report";
            break;
        case "ER":
            reportName = "ScopeConnect Report";
            break;
    }
    return reportName;
};

export const getDeliveredReportNames = (order) => {
    let reportNamesArray = [];
    const qmArray= ['SF', 'MF', 'CM']
    order.map((item) => {
        if (item.productTypeCode.includes("QM") === true || qmArray.includes(item.productTypeCode)=== true) {
            reportNamesArray.push(getReportNames("RM"));
        }
        if (item.productTypeCode.includes("QS") === true) {
            if (item.services.length > 0) {
                item.services.map((item) => {
                    if (item.fulfillmentStatus === "Success") {
                        if (item.serviceTypeCode === "RC") {
                            reportNamesArray.push(getReportNames("RC"));
                        }
                        if (item.serviceTypeCode === "WHPI") {
                            reportNamesArray.push(getReportNames("WHPI"));
                        }
                        if (item.serviceTypeCode === "BC") {
                            reportNamesArray.push(getReportNames("BC"));
                        }
                    }
                });
            } else {
                reportNamesArray.push(item.productDescription);
            }
        }
        if (item.productTypeCode.includes("CC") === true) {
            reportNamesArray.push(item.productDescription);
        }
    });

    return reportNamesArray;
};


export const getDeliveredReportNamesForSingleOrder = (order) => {
    let reportNamesArray = [];
    if (order.services.length > 0) {
        const rmReportsArray = order.services.filter(
            (item) =>
                item.serviceTypeCode === "RM" &&
                item.fulfillmentStatus === "Success"
        );
        if (rmReportsArray.length > 0) {
            reportNamesArray.push(getReportNames("RM"));
        }
        order.services.map((item) => {
            if (item.fulfillmentStatus === "Success") {
                if (item.serviceTypeCode === "RC") {
                    reportNamesArray.push(getReportNames("RC"));
                }
                if (item.serviceTypeCode === "WHPI") {
                    reportNamesArray.push(getReportNames("WHPI"));
                }
                if (item.serviceTypeCode === "BC") {
                    reportNamesArray.push(getReportNames("BC"));
                }
            }
        });
        if (order.productTypeCode.includes("CC") === true) {
            reportNamesArray.push(order.productDescription);
        }
    }
    return reportNamesArray;
}

export const getReportStatusDetails = (order) => {
    let reportStatusArray = [];
    if (order.services.length > 0) {
        const rmReportsArray = order.services.filter(
            (item) => item.serviceTypeCode === "RM"
        );
        if (rmReportsArray.length > 0) {
            reportStatusArray.push({
                reportName: getReportNames("RM"),
                reportStatus: rmReportsArray[0].fulfillmentStatus,
                errorCode: rmReportsArray[0].errorCode,
            });
        }
        order.services.map((item) => {
            if (item.serviceTypeCode === "RC") {
                reportStatusArray.push({
                    reportName: getReportNames("RC"),
                    reportStatus: item.fulfillmentStatus,
                    errorCode: item.errorCode,
                });
            }
            if (item.serviceTypeCode === "WHPI") {
                reportStatusArray.push({
                    reportName: getReportNames("WHPI"),
                    reportStatus: item.fulfillmentStatus,
                    errorCode: item.errorCode,
                });
            }
            if (item.serviceTypeCode === "BC") {
                reportStatusArray.push({
                    reportName: getReportNames("BC"),
                    reportStatus: item.fulfillmentStatus,
                    errorCode: item.errorCode,
                });
            }
            if (item.serviceTypeCode === "ER") {
                reportStatusArray.push({
                    reportName: getReportNames("ER"),
                    reportStatus: item.fulfillmentStatus,
                    errorCode: item.errorCode,
                });
            }
        });
    }
    return reportStatusArray;
};

// Filtering Discount bundles as per ProductId and PropertyType
export const getFilteredDiscountBundles = (groupByBundleCode,selectedProductArray) => {
    let newfilteredData = [];
    const filteredData = groupByBundleCode.filter((bundleArray) => {
        return selectedProductArray.every((productItem) => {
          return bundleArray.some((bundleItem) => {
            return (
              bundleItem.productId === productItem.productId &&
              bundleItem.propertyType === productItem.propertyType
            );
          });
        });
      });
    newfilteredData =  filteredData.filter((item) =>(
        item.length === selectedProductArray.length
    ))
    return newfilteredData
}

// Grouping of Orders on GroupId and then sorting them in descending order
// Showing sorted order in QM/QS/SC sequence in each group.
export const taskGroupData = (data) => {
    // Grouping by GroupOrderId and then sorting them in descending order
    let groupByGroupId = data.result.reduce((result, order) => {
        const groupOrderID = order.groupOrderId;
        // Check if the groupOrderID key exists, if not, create an empty array
        if (!result[groupOrderID]) {
            result[groupOrderID] = [];
        }
        // Push the current order object into the array for the groupOrderID
        result[groupOrderID].push(order);
        return result;
    }, []);
    const arrayOfOrders = Object.values(groupByGroupId);
    arrayOfOrders.sort((a, b) => (b[0].groupOrderID > a[0].groupOrderID) ? 1 : -1);

    // Custom sorting function - To re-arrange order in sequence QM/SC/CC
    const sortOrderByReportType = ["QM", "QS", "CC"];

    (arrayOfOrders as any[]).forEach((subarray) => {
        subarray.sort((a, b) => sortOrderByReportType.indexOf(a.productTypeCode.substring(3, 5)) - sortOrderByReportType.indexOf(b.productTypeCode.substring(3, 5)));
    });
    
    return arrayOfOrders
}
